/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureDevops extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureDevops");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureDevops.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureDevops>): ServiceAccountCredentialsForAzureDevops {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureDevops(), model);
        ServiceAccountCredentialsForAzureDevops.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureDevops>): ServiceAccountCredentialsForAzureDevops {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureDevops.newInstance(<ServiceAccountCredentialsForAzureDevops> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureDevops) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureDevops.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureDevops): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureDevops.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Personal Access Token. This is a required field.
     */
    personalaccesstoken: string;

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

    /**
     * Organization. This is a required field.
     */
    organization: string;

}
